function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, "\n            .cls-1{fill:none}\n        "));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  id: "Path_176",
  d: "M0 0h37v37H0z",
  className: "cls-1",
  "data-name": "Path 176"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  id: "Path_177",
  d: "M7.083 10a3.083 3.083 0 1 0 3.083 3.083A3.092 3.092 0 0 0 7.083 10zm18.5 0a3.083 3.083 0 1 0 3.083 3.083A3.092 3.092 0 0 0 25.583 10zm-9.25 0a3.083 3.083 0 1 0 3.083 3.083A3.092 3.092 0 0 0 16.333 10z",
  className: "dotes",
  "data-name": "Path 177",
  transform: "translate(2.167 5.417)"
});

var SvgDotes = function SvgDotes(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "more_horiz-24px",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDotes, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dotes.984c6868.svg";
export { ForwardRef as ReactComponent };